import PropTypes from 'prop-types';
import React from 'react';

import './welcome.scss';

const Welcome = ({siteOptions}) => {
  const introQuote = siteOptions.introQuote ? <h2 className="title-text">{siteOptions.introQuote}</h2> : null;
  return introQuote || siteOptions.introCopy ? (
    <div className="container web-container">
      <div className="welcome-wrapper row">
        <div style={{
          height: '75px'
        }}></div>
        <p className="header-standard">Welcome</p>
        <div className="header-separator"></div>
        {introQuote}
        <p className="text-block">{siteOptions.introCopy}</p>
      </div>
    </div>
  ) : null;
};

Welcome.propTypes = {
  siteOptions: PropTypes.object.isRequired
};

export default Welcome;



// WEBPACK FOOTER //
// ./src/components/homepage/welcome/welcome.js